import React from 'react';
import { useSelector } from 'react-redux';
import { Wrapper } from './style';

// Components
import Text from 'components/common/Text';
import Link from 'components/common/Link';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const BreadCrumbs = ({ list, ...rest }) => {
	const {webConfig} = useSelector(state => state.core);

	return (
	<Wrapper {...rest}>
		{list.map((r, i) => (
			i === list.length - 1
				? 
				<Link 
					key={r.key} 
					to={r.to}
					params={r.params}
				>
					<Text className="active" weight="m">{r.label}</Text>
				</Link>
				:	(
					<span
						key={r.key} 
						className='row-flex'
					>
						<Link 
							key={r.key} 
							to={r.to}
							params={r.params}
						>
							<Text className="text" weight="m">{r.label}</Text>
						</Link>
						{webConfig.dir === 'rtl'
						?
						<ArrowBackIosIcon className="arrow-left arrow" />
						:
						<ArrowForwardIosIcon className="arrow-right arrow" />
						}

					</span>
				)
		))}
	</Wrapper>
	)
};

export default BreadCrumbs;
